module.exports = __webpack_public_path__ + "static/media/writech.b1eebe53.png";